import elementIsVisible from '../../core/INF-elementIsVisible';

const videosShouldPlay = () => {
  const siteOverlayActive = document.querySelector('[data-site-overlay]').classList.contains('SiteOverlay--active');
  const mobileMenuOpen = document.querySelector('[data-state]').classList.contains('State--mobile-menu-open');
  const cartOpen = document.querySelector('[data-state]').classList.contains('State--cart-open');
  const modalOpen = document.querySelector('[data-state]').classList.contains('State--modal-open');

  return !(siteOverlayActive || mobileMenuOpen || cartOpen || modalOpen);
};

export default function playVideos(players, type) {
  Object.keys(players).forEach((player_id) => {
    const player = players[player_id];
    const $player = document.getElementById(player_id);

    if (type === 'youtube' && !player.playVideo) {
      return;
    }

    if (type === 'vimeo' && !player.play) {
      return;
    }

    if (elementIsVisible($player) && !$player.dataset.manuallyPaused && videosShouldPlay()) {
      if (type === 'youtube') {
        player.playVideo();
      } else {
        $player.closest('.BackgroundVideo').classList.add('BackgroundVideo--init');
        player.play();
      }
    } else if (type === 'youtube') {
      player.pauseVideo();
    } else {
      player.pause();
    }
  });
}
